import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';

const UnauthenticatedLayout = () => {
  return (
    <div >
      <Navbar />
      <Outlet />
    </div>
  );
};

export default UnauthenticatedLayout;

